import { useState } from 'react'

import useTransactionTypes from '../useTransactionTypes/useTransactionTypes'

const useOrderError = () => {
  const [showOrderErrorModal, setShowOrderErrorModal] = useState(false)
  const { allowsUnifiedFlow } = useTransactionTypes()

  const isOrderReturnable = ({
    availableTransactionTypesForOrder,
    lineItems,
    transactionTypeSelectedByUser,
    lineItemGroups,
  }) => {
    if (lineItems?.length || lineItemGroups?.length) {
      if (allowsUnifiedFlow) {
        return availableTransactionTypesForOrder.length > 0
      } else {
        return availableTransactionTypesForOrder.includes(transactionTypeSelectedByUser)
      }
    }

    return false
  }

  return {
    isOrderReturnable,
    showOrderErrorModal,
    setShowOrderErrorModal,
  }
}

export default useOrderError
